import { handleActions } from 'redux-actions';

const initialValue = {
  error: null,
  current: null,
  currentLoading: false,
  sidebar: null,
  throttle: null,
  showPromotionsModal: false
}

export default handleActions({
  PROFILE_SELECT(state, { payload }) {
    return { ...state, current: payload }
  },

  PROFILE_LOAD_PENDING(state) {
    return { ...state, currentLoading: true }
  },

  PROFILE_LOAD_FULFILLED(state, { payload }) {
    return {
      ...state,
      current: {
        ...payload,
        retrievedAt: Date.now()
      },
      currentLoading: false
    }
  },

  PROFILE_LOAD_REJECTED(state, { payload }) {
    return {
      ...state,
      currentLoading: false,
      error: payload.message
    }
  },

  SIDEBAR_LOAD_FULFILLED(state, { payload }) {
    return { ...state, sidebar: payload }
  },

  THROTTLE_LOAD_FULFILLED(state, { payload }) {
    return { ...state, throttle: payload }
  },

  SHOW_PROFILE_PROMOTIONS_MODAL(state) {
    return { ...state, showPromotionsModal: true }
  },

  HIDE_PROFILE_PROMOTIONS_MODAL(state) {
    return { ...state, showPromotionsModal: false }
  },

  PROMOTION_DISCOUNTS_LOAD_FULFILLED(state, { payload }) {
    return {
      ...state,
      current: {
        ...state.current,
        promotion_discounts: payload
      }
    }
  }
}, initialValue)

const ProfileSelectors = {
  getUserSidebar(state) {
    return state.profiles.sidebar
  },

  getUserThrottle(state) {
    return state.profiles.throttle
  },

  getCurrentUserProfile(state) {
    // only return signed-in user profile record
    if (state.session.user && state.profiles.current && state.profiles.current.username === state.session.user.username) {
      return state.profiles.current
    }
  },

  getUserPlan(state) {
    const profile = state.profiles.current
    return (profile && profile.subscription) ? profile.subscription.plan : null
  },

  getUserSubscription(state) {
    const profile = state.profiles.current
    return profile ? profile.subscription : null
  },

  getUserFeedsAvailable(state) {
    const
      subscription = this.getUserSubscription(state),
      feedLimit = subscription?.limits?.feeds || 0,
      currentFeedCount = state.feeds.feeds.length

    return Math.min(feedLimit - currentFeedCount)
  }
}

export { ProfileSelectors }
